import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import GuidelinesList from 'src/modules/community/communityAbout/components/guidelinesList';
import { Subtitle } from 'src/modules/community/communityAbout/components/sharedStyles';
import Icon from 'src/components/icon';

export default function GuidelinesHighlights() {
  const guidelines = useSelector(({ context }) => context.currentCommunity?.guidelines);
  const extendedGuidelinesUrl = useSelector(({ context }) => context.currentCommunity?.extendedGuidelinesUrl);
  if (!guidelines) return null;

  return (
    <GuidelinesSection>
      <Subtitle>{i18n.t('Guidelines Highlights')}</Subtitle>
      <GuidelinesList guidelines={guidelines} />
      {extendedGuidelinesUrl && (
        <ExtendedGuidelinesLink href={extendedGuidelinesUrl}>
          {i18n.t('View detailed guidelines')}<Icon icon="open-right"/>
        </ExtendedGuidelinesLink>
      )}
    </GuidelinesSection>
  );
}

const GuidelinesSection = styled.div`
  margin-bottom: 45px;
`;

const ExtendedGuidelinesLink = styled.a`
  margin: 20px 0;
`;
